import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import CustomerPageLayout from "../../customer-page-layout/CustomerPageLayout";
import Button from "../../../../common/ekedc-components/button/Button";
import { PasscodeOTPInput } from "../../onboarding/components";
import { CheckmarkCircleSmIcon } from "../../../../assets/icons";
import { useVerifyNinPhoneOtpMutation, useInitiateNinPhoneVerificationMutation } from "../../../../service/vending-service";
import { setEnergyProfileInfo } from "../../../../stores/slices/customer-energy-profile-slice";
import { getErrorMessage } from "../../../../utils/error-handler";
import { ApplicationRoutes } from "../../../../routes";
import styles from "./account-activities-nin-verification.module.scss";

export const AccountActivitiesNinVerificationPage = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const { phoneNumber = "" } = (location.state ?? {}) as { phoneNumber?: string };
	const [otp, setOtp] = useState("");
	const [isVerified, setIsVerified] = useState(false);

	const [verifyNinPhoneOtp, { isLoading: isVerifying }] = useVerifyNinPhoneOtpMutation();
	const [initiateNinPhoneVerification] = useInitiateNinPhoneVerificationMutation();

	const handleContinue = async () => {
		if (isVerified) {
			navigate(`/${ApplicationRoutes.CUSTOMER_ACCOUNT_ACTIVITIES}`);
			return;
		}
		if (otp.length < 6 || isVerifying) return;
		try {
			await verifyNinPhoneOtp({ otp }).unwrap();
			dispatch(setEnergyProfileInfo({ isNinPhoneNumberVerified: true }));
			setIsVerified(true);
		} catch (err: any) {
			toast.error(getErrorMessage(err?.data));
		}
	};

	const handleResendOtp = async () => {
		try {
			await initiateNinPhoneVerification().unwrap();
		} catch (err: any) {
			toast.error(getErrorMessage(err?.data));
		}
	};

	return (
		<CustomerPageLayout title={t("energyManagement.ninVerificationTitle")} showBackButton onBack={() => navigate(-1)}>
			<form className={styles.form} onSubmit={e => { e.preventDefault(); handleContinue(); }}>
				{isVerified ? (
					<div className={styles.verifiedCard}>
						<CheckmarkCircleSmIcon className={styles.verifiedIcon} />
						<span className={styles.verifiedText}>{t("account.web.ninVerified")}</span>
					</div>
				) : (
					<PasscodeOTPInput
						value={otp}
						onChange={setOtp}
						onResend={handleResendOtp}
						otpLength={6}
						resendTimerSeconds={180}
						sendToEmail={false}
						contact={phoneNumber}
						dialCode=""
						renderSeparator={true}
						className={styles.themedOtp}
					/>
				)}

				<div className={styles.buttonSection}>
					<Button type="submit" text={t("common.actions.continueKey")} loading={isVerifying} loadingText={t("account.web.verifying")} disabled={!isVerified && otp.length < 6} />
				</div>
			</form>
		</CustomerPageLayout>
	);
};

export default AccountActivitiesNinVerificationPage;
